class SlidingPanel {

	panel;
	topPanel;
	otherPanels = [];
	triggerPosStart;
	triggerPosEnd;

	constructor(panel, offset=10) {
		this.panel = $(panel);
		this.topPanel = $('.top-panel', panel);
		this.setInitialPositions(-100);

		$(window).on('scroll', () => this.setPositions($(window).scrollTop()));
		$(window).on('resize', () => this.setInitialPositions(offset));
	}

	setInitialPositions(offset) {

		this.triggerPosStart = this.topPanel.outerHeight() + this.topPanel.parent().position().top - $(window).height() + 150;
		var otherPanels = [];
		var totalHeight = this.triggerPosStart;

		$('.sub-panel', this.panel).each(function (i, e) {
			$(e).css('z-index', i * -3 + 50);
			otherPanels[otherPanels.length] = { "Panel": e, "Index": i, "Height": $(e).outerHeight() };
			totalHeight += $(e).outerHeight();
		});

		this.otherPanels = otherPanels;
		if ($(window).outerHeight() < 850) {
			this.triggerPosEnd = totalHeight - 450;
		} else {
			this.triggerPosEnd = totalHeight - 350;
        }

		var prevHeight = 0;
		var totalHeight = 0;
		for (var i = 0; i < this.otherPanels.length; i++) {
			let $panel = $(this.otherPanels[i].Panel);
			prevHeight = i > 0 ? prevHeight + $(this.otherPanels[i - 1].Panel).outerHeight() : 0;
			$panel.css('top', this.topPanel.outerHeight() - $panel.outerHeight() - offset + 'px');
			$panel.data('st', this.topPanel.outerHeight() - $panel.outerHeight() - offset);
			$panel.data('mx', this.topPanel.outerHeight() + prevHeight);
			totalHeight += $panel.outerHeight();

			//console.log('PANEL:' + i + ' st=' + (this.topPanel.outerHeight() - $panel.outerHeight() - offset) + '  mx=' + (this.topPanel.outerHeight() + prevHeight));
		}

		// Set height of parent
		this.topPanel.parent().outerHeight(this.topPanel.outerHeight() + totalHeight);

		this.setPositions($(window).scrollTop());
	}

	setPositions(windowScroll) {
		if (windowScroll > this.triggerPosStart) {
			var relPos = windowScroll - this.triggerPosStart;
			//console.log(relPos);
			var min = 0;
			var relMin = this.triggerPosStart;
			var relMax = this.triggerPosEnd;

			for (var i = 0; i < this.otherPanels.length; i++) {
				let $panel = $(this.otherPanels[i].Panel);

				var max = $panel.data('st');
				var fmx = $panel.data('mx');
				var R = (relMax - relMin) / (max - min);
				var pos = max + relPos / R;
				
				$panel.css('top', pos > fmx ? fmx : pos + 'px');
			}
		}
	}
}

export { SlidingPanel };